import { AppTheme } from "./types";

const weu: AppTheme = {
  name: "weu",
  colors: {
    primary: "#0F1E6C",
    background: "#f3f4f6",
    home: "#ffffff",
    text: "#0F1E6C",
    icon: "#46B6D0",
    bgRecent: "ffffff",
    backgroundGradient: "linear-gradient(to right, #0F1E6C, #CAD1F5)",
    text2: "[#0F1E6C]",
  },
  assets: {
    logo: "/images/main_logo.svg",
    logoNavbar: "/images/main_logo.svg",
    iconBasePath: "/assets/icons/weu/",
  },
  options: {
    grayscaleLogo: true,
    iconCategories: [
      { label: "맛집", image: "1.png" },
      { label: "기타", image: "5.png" },
      { label: "기자단", image: "9.png" },
      {
        label: "광고문의",
        image: "10.png",
        link: "/contact",
      },
      {
        label: "WEU Beauty",
        image: "weu_beauty.svg",
        link: "https://weubeauty.kr",
      },
    ],
    typeIcons: {
      blog: {
        active: "/assets/icons/weu/iconUpdate/naver_select.jpg",
        label: "블로그",
      },
      instagram: {
        active: "/assets/icons/weu/iconUpdate/insta_select.jpg",
        label: "인스타그램",
      },
      tiktok: {
        active: "/assets/icons/weu/iconUpdate/tictok_select.jpg",
        label: "틱톡",
      },
      youtube: {
        active: "/assets/icons/weu/iconUpdate/youtube_select.jpg",
        label: "유튜브",
      },
      all: {
        active: "/assets/icons/weu/iconUpdate/weu_select.jpg",
        label: "위유",
      },
    },
  },
};

export default weu;
